module.exports = __webpack_public_path__ + "static/media/veryvell_3_filter.98f85213.png";